import styled from 'styled-components';

export const Container = styled.div`
    flex: 1;
    width: 100%;
`;

export const ButtonRow = styled.div`
    width: 100%;
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
`;

export const Button = styled.div.attrs(props => ({
    style: props.width ? {
        width: props.width
    } : {
        flex: 1
    }
}))`
    height: 30px;
    background-color: transparent;
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    transition: all .3s ease 0s;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    :hover {
        background-color: ${props => props.color};
        color: #000;
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
`;

export const AbilityForm = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const Label = styled.div`
    font-size: 12px;
    color: #999;
    flex: 1;
    text-transform: uppercase;

    &.varibles {
        margin-left: 5px;
    }
`;

export const NormalLabel = styled.div`
    font-size: 12px;
    color: #ccc;
    flex: 1;
    margin: 0 -30px 0 5px; 
`;

export const Input = styled.input`
    border: 1px solid #555;
    background-color: #111;
    height: 30px;
    min-height: 30px;
    padding: 0 5px;
    margin: 0 1px 10px;
    flex: 1;
    color: #999;

    &.nomargin {
        margin: 0;
    }

    &.tiny {
        width: 40px;
    }
`;

export const TextArea = styled.textarea`
    border: 1px solid #555;
    background-color: #111;
    height: 90px;
    padding: 0 5px;
    margin: 0 1px 10px;
    width: calc(100% - 2px);
    color: #999;
    resize: none;
`;

export const FormRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;

    &.spaced {
        margin: 10px 0 0;
    }

    &.hideButton ${Button} {
        opacity: 0;
    }
    &.hideButton:hover ${Button} {
        opacity: 1;
    }
`;

export const AbilityItem = styled.div`
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
`;

export const AbilityName = styled.div`
    font-size: 14px;
    color: #aaa;
    flex: 1;
`;

export const AbilityVariablesWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-right: 10px;
`;

export const AbilityVariablesItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    margin-left: 10px;
`;

export const AbilityLabel = styled.div`
    font-size: 12px;
`;